import get from 'lodash/get';

export const isQualificationRejection = (error) => {
  try {
    if (get(error, 'response.status') !== 403) return false;
    const data = get(error, 'response.data');
    return typeof data?.message === 'string' && typeof data?.image === 'string';
  } catch (e) {
    return false;
  }
};

export const getQualificationRejectionData = (error) => {
  if (!isQualificationRejection(error)) return null;
  const { message, image } = error.response.data;
  return { message, image };
};

/**
 * @see docs/worklog/maintenance/20093-investigate-facebook-auth-errors/rfc-frontend.md
 */
